import { AddButton } from "../../components/AddButton";
import {
	Datagrid,
	Pagination,
	ReferenceField,
	ReferenceManyField,
	Show,
	SimpleShowLayout,
	Tab,
	TabbedShowLayout,
	TextField,
	useRecordContext,
} from "react-admin";
import { RemoveWithConfirmButton } from "../../components/RemoveWithConfirmButton";
import { TeamRecord } from "./types";
import { TeamUserRecord } from "../team_users/types";
import { UserName } from "../../components/UserName";
import { useTeamRoleAssignmentPermission } from "../../permissions";

const AddUserToTeamButton = () => {
	const team = useRecordContext<TeamRecord>();
	const { hasPermissionForAnyRole: teamUserCreatePermission } =
		useTeamRoleAssignmentPermission("team-users.create");

	return teamUserCreatePermission(team.id) ? (
		<AddButton
			resource="team-users"
			foreignKey="team_id"
			label="Add new user"
		/>
	) : null;
};

const DisassociateUserFromTeamButton = () => {
	const teamUser = useRecordContext<TeamUserRecord>();
	const { hasPermissionForRole: teamUsersDeletePermission } =
		useTeamRoleAssignmentPermission("team-users.delete");

	return teamUsersDeletePermission(teamUser.team_id, teamUser.role_id) ? (
		<RemoveWithConfirmButton
			confirmContent="Are you sure you want to disassociate the user?"
			notifyMessage="User disassociated"
		/>
	) : null;
};

export const TeamShow = () => (
	<Show title="Team view">
		<SimpleShowLayout>
			<TextField source="name" />
		</SimpleShowLayout>
		<TabbedShowLayout>
			<Tab label="Users">
				<ReferenceManyField
					label={false}
					reference="team-users"
					target="team_id"
					pagination={<Pagination />}
				>
					<Datagrid
						bulkActionButtons={false}
						rowClick={(id, resource, record) => `/users/${record.user_id}/show`}
					>
						<ReferenceField
							source="user_id"
							reference="users"
							link="show"
							label="Full Name"
							sortable={false}
						>
							<UserName />
						</ReferenceField>
						<ReferenceField source="role_id" reference="roles" link={false}>
							<TextField source="name" />
						</ReferenceField>
						<DisassociateUserFromTeamButton />
					</Datagrid>
				</ReferenceManyField>
				<AddUserToTeamButton />
			</Tab>
			<Tab label="Organs" path="organs">
				<ReferenceManyField
					label={false}
					reference="organ-teams"
					target="team_id"
				>
					<Datagrid
						bulkActionButtons={false}
						rowClick={(id, resource, record) =>
							`/organs/${record.organ_id}/show`
						}
					>
						<ReferenceField
							source="organ_id"
							reference="organs"
							link="show"
							label="Name"
						>
							<TextField source="name" />
						</ReferenceField>
					</Datagrid>
				</ReferenceManyField>
			</Tab>
		</TabbedShowLayout>
	</Show>
);
